module.exports = __webpack_public_path__ + "static/media/Cruise Bingo.43859b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/multiplayer_card_images/Cruise Bingo.png
// module id = 668
// module chunks = 0